import React, { useEffect, useState } from "react";
import Editor from "../../../components/Editor";
import { Button } from "../../../components/ui/button";
import { API, fileUpload } from "../../../config";
import CustomLabelText from "../../../components/CustomLabelText";
import { Label } from "../../../components/ui/label";
import { Input } from "../../../components/ui/input";
import { useOrganization } from "../../../lib/context/OrganisationContext";

const EmailConsent = ({
  templateData,
  setLoading,
  fetchTemplateData,
  trustId,
  org = false,
}) => {
  const { organizationData } = useOrganization();
  const defaultText = `<p>We are writing to inform you of upcoming changes to Australia’s Anti-Money Laundering and Counter-Terrorism Financing (AML/CTF) regime that may affect your engagement with our firm.</p><p>The Australian Government is expanding AML/CTF obligations to include accounting professionals under the proposed “Tranche 2” reforms. These changes are expected to require firms like ours to undertake enhanced Customer Due Diligence (CDD) and ongoing monitoring of client relationships.</p><p><br></p><p>As part of these obligations, we will be required to collect and verify additional information from you, including:</p><ul><li>Identity verification documentation (where not already obtained or requiring refresh regularly)</li><li>Information relating to your business activities</li><li>Source of funds and source of wealth details for certain transactions or engagements (designated service)</li><li>Ongoing updates where there are changes to your circumstances</li></ul><p>These measures are designed to strengthen Australia’s financial system and align with international AML/CTF standards.</p><p><br></p><p>We understand that providing additional information may be an inconvenience; however, these requirements are mandated by law and will be necessary for us to continue providing services to you. We have chosen TrustEasy, a part of Myna Australia Pty Ltd, to help us with conducting the ID verification using SMS and Biometrics flow.</p><p><br></p><p>We will contact you directly if further information or documentation is required. In the meantime, we encourage you to review the following AUSTRAC resources for more information:</p><ul><li><strong>AUSTRAC AML/CTF reforms overview:</strong> <a href="https://www.austrac.gov.au/newly-regulated-businesses-get-ready-reforms" rel="noopener noreferrer" target="_blank">https://www.austrac.gov.au/newly-regulated-businesses-get-ready-reforms</a></li><li><strong>Customer Due Diligence guidance:</strong> <a href="https://www.austrac.gov.au/business/core-guidance/customer-due-diligence" rel="noopener noreferrer" target="_blank">https://www.austrac.gov.au/business/core-guidance/customer-due-diligence</a></li></ul><p><br></p><p>If you have any questions about how these changes may impact you, please do not hesitate to contact our office.</p><p>We appreciate your cooperation and understanding as we implement these important regulatory requirements.</p>`;
  const [subject, setSubject] = useState(
    templateData?.subject ? templateData?.subject : "AML Notification",
  );

  const [value, setValue] = useState(
    templateData?.template ? templateData?.template : defaultText,
  );

  useEffect(() => {
    setSubject(templateData?.subject ? templateData?.subject : "AML Notification")
    setValue(templateData?.template ? templateData?.template : defaultText);
  }, [defaultText, templateData]);

  const handleSave = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      if (org) {
        formData.append(
          "organization_id",
          organizationData?.organizationId
            ? organizationData?.organizationId
            : "",
        );
      }
      formData.append("trust_id", trustId);
      formData.append("value", value);
      formData.append("subject", subject);
      formData.append("type", "email-consent");
      formData.append("_method", "put");
      const { data } = await fileUpload(
        org
          ? `${API.TEMPLATE_UPADATE}/${
              organizationData?.organizationId
                ? organizationData?.organizationId
                : ""
            }`
          : `${API.TEMPLATE_UPADATE}/${trustId ? trustId : ""}`,
        formData,
      );
      if (data) {
        fetchTemplateData();
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="grid gap-2 mb-3">
        <Label htmlFor="subject">
          <CustomLabelText
            required={true}
            labelText="Subject"
            errorField={""}
          />
        </Label>
        <Input
          id="subject"
          placeholder="Enter Subject"
          name="subject"
          onChange={(e) => {
            setSubject(e.target.value);
          }}
          value={subject}
        />
      </div>
      <Editor value={value} setValue={(data) => setValue(data)} />
      <div className="flex w-full items-center justify-between mt-4">
        <Button
          onClick={() => {
            handleSave();
          }}
        >
          Save
        </Button>
      </div>
    </>
  );
};

export default EmailConsent;
